module.exports = __webpack_public_path__ + "static/media/1.92cd1798.svg";